import CrownIcon from 'assets/Icons/CrownIcon';
import { useRouter } from 'next/router';
import React from 'react';

import {
  borderColorClassName,
  borderT,
  headerHeight,
} from '@/components/PlatformSubscription/PlanTable';
import Cell from '@/components/PlatformSubscription/PlanTable/Columns/Cell';

interface HeaderColumnProps {
  isAffiliate?: boolean;
}

const HeaderColumn: React.FC<HeaderColumnProps> = ({
  isAffiliate: isAffiliateProp,
}) => {
  const router = useRouter();
  const isAffiliate =
    isAffiliateProp ?? router?.pathname?.includes('affiliate');

  return (
    <div className='border-y border-transparent min-w-[250px]'>
      <div
        className='flex flex-col justify-center gap-5'
        style={{ height: headerHeight }}
      >
        {isAffiliate ? (
          <>
            <div className='flex items-center gap-3'>
              <CrownIcon width={36} height={36} className='shrink-0' />
              <p className='text-xl md:text-2xl font-bold tracking-wide text-[#D3A984] uppercase font-sans'>
                ZEBRALEARN PRIME
              </p>
            </div>

            <div className='flex flex-col gap-3 pr-4'>
              <div className='flex items-center gap-2.5'>
                <CrownIcon width={18} height={18} className='shrink-0' />
                <p className='text-sm md:text-[15px] leading-snug'>
                  <span className='font-semibold text-white'>No auto-renewal</span>{' '}
                  <span className='font-normal text-[#C4C4C4]'>
                    without your consent
                  </span>
                </p>
              </div>

              <div className='flex items-center gap-2.5'>
                <CrownIcon width={18} height={18} className='shrink-0' />
                <p className='text-sm md:text-[15px] leading-snug'>
                  <span className='font-normal text-[#C4C4C4]'>
                    Unlock all app
                  </span>{' '}
                  <span className='font-semibold text-white'>premium features</span>
                </p>
              </div>

              <div className='flex items-center gap-2.5'>
                <CrownIcon width={18} height={18} className='shrink-0' />
                <p className='text-sm md:text-[15px] leading-snug'>
                  <span className='font-normal text-[#C4C4C4]'>Access on</span>{' '}
                  <span className='font-semibold text-white'>any device</span>
                </p>
              </div>

              <div className='flex items-center gap-2.5'>
                <CrownIcon width={18} height={18} className='shrink-0' />
                <p className='text-sm md:text-[15px] leading-snug'>
                  <span className='font-semibold text-white'>Unlimited access</span>{' '}
                  <span className='font-normal text-[#C4C4C4]'>of books</span>
                </p>
              </div>
            </div>
          </>
        ) : null}
      </div>

      {/* <H1Cell
        className={`
                  ${borderColorClassName}
                  ${borderT}
               
                  `}
        title='What is inside'
      /> */}
      {/* <H2Cell title='What you will get:' /> */}
      {/* <Cell
        style={{ marginLeft: typeMarginLeft }}
        className={`
            ${borderColorClassName}
            ${borderL}
            `}
        title='Digital Copy'
      /> */}
      {/* <Cell
        style={{ marginLeft: typeMarginLeft }}
        className={`
            ${borderColorClassName}
            ${borderL}
            `}
        title='Hard Copy'
      /> */}
      <Cell
        className={`
                  ${borderColorClassName}
                  ${borderT}
               
                  `}
        title='eBooks'
      />

      <Cell title='Video Summary' />
      <Cell title='AudioBooks' />
      <Cell title='Certification' />
      <Cell title='App Access' />
      <Cell title='Upgrade to Hardcopy' />
    </div>
  );
};

export default HeaderColumn;
